import { createAction, props } from '@ngrx/store';
import { SearchExport, SearchExportListPagination, StartSearchExportResponse } from '../../services/search-export.service';

// Start Export
export const startSearchExport = createAction(
  '[Search Export] Start Export',
  props<{ search?: string; tags?: { [key: string]: string[] } | null; archived?: boolean; workspace_id?: number; sort_by?: string; sort_dir?: 'asc' | 'desc'; date_range?: string; search_report_ids?: number[] }>()
);

export const startSearchExportSuccess = createAction(
  '[Search Export] Start Export Success',
  props<{ result: StartSearchExportResponse }>()
);

export const startSearchExportFailure = createAction(
  '[Search Export] Start Export Failure',
  props<{ error: any }>()
);

// Load Exports List
export const loadSearchExports = createAction(
  '[Search Export] Load Exports',
  props<{ status?: string; page?: number; perPage?: number }>()
);

export const loadSearchExportsSuccess = createAction(
  '[Search Export] Load Exports Success',
  props<{ exports: SearchExport[]; pagination: SearchExportListPagination }>()
);

export const loadSearchExportsFailure = createAction(
  '[Search Export] Load Exports Failure',
  props<{ error: any }>()
);

// Download Export
export const downloadSearchExport = createAction(
  '[Search Export] Download Export',
  props<{ exportId: number; fileName?: string }>()
);

export const downloadSearchExportSuccess = createAction(
  '[Search Export] Download Export Success',
  props<{ exportId: number }>()
);

export const downloadSearchExportFailure = createAction(
  '[Search Export] Download Export Failure',
  props<{ exportId: number; error: any }>()
);

// Reset
export const resetSearchExportState = createAction(
  '[Search Export] Reset State'
);

export const resetStartExportState = createAction(
  '[Search Export] Reset Start Export State'
);
